<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="this.page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="联系人" slot="people" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.contactName }}</div>
          <div>{{ row.contactPhone }}</div>
        </template>
      </el-table-column>
      <el-table-column label="省市区" slot="operationAddress" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.province }}{{ row.city }}{{ row.region }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商家地址" slot="operationAddress" align="center">
        <template slot-scope="{ row }">
          <el-tooltip :content="row.merchantAddress" placement="top">
            <p
              style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"
            >
              {{ row.merchantAddress }}
            </p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="合作门店" slot="storeCount" align="center">
        <template slot-scope="{ row }">
          <span
            v-if="row.storeCount"
            style="
              color: #0981ff;
              border-bottom: 1px solid #0981ff;
              cursor: pointer;
            "
            @click="storeCountFn(row)"
          >
            {{ row.storeCount }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="报价品类" slot="quoteMachineType" width="160" align="center">
        <template slot-scope="{ row }">
          <div>{{row.quoteMachineType == '01'?'全品类':'指定品类'}}</div>
          <div v-if="row.quoteMachineType == '02'">
            <el-tag type="success" style="margin-right:5px" size="mini" v-for="(item,index) in row.assignQuoteMachineType" :key="index">{{item=='tablet'?'平板':item=='other'?'其他':item=='laptop'?'笔记本':item=='mobile'?'手机':''}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="营业执照" slot="operation" align="center">
        <template slot-scope="{ row }">
          <img
            style="width: 70px; height: 70px"
            :src="row.businessLicense"
            alt=""
            @click="seeImg(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="报价状态" slot="operation" align="center">
        <template slot-scope="{ row }">
          <span :style="row.companyIsEnable == '01' ? 'color:#0981FF' : ''">{{
            row.companyIsEnable == "01" ? "已开启" : "已关闭"
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="150" label="报价启用/禁用" slot="operation" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.companyIsEnable==='01'" class="handleClass">
            <el-button
              size="mini"
              type="danger"
              round
              @click="handleBtn(row, 'danger')"
            >禁用
            </el-button>
          </span>
          <span v-else class="handleClass">
            <el-button
              size="mini"
              type="primary"
              round
              @click="handleBtn(row, 'success')"
            >启用
            </el-button>
          </span>
        </template>
      </el-table-column> -->
    </GlobalTable>

    <!-- 启用禁用弹窗 -->
    <GlobalDialog
      :title="dialogTitle"
      :show="dialogVisible"
      :width="dialogWidth"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      @onClose="onClose"
    >
      <div v-if="dialogTitle == '禁用'" style="color: #ff687b">
        禁用后该商家不在参与报价
      </div>
      <div style="font-size: 16px; color: #666666">{{ tipValue }}</div>
    </GlobalDialog>
    <DialogTbale
      @onClose="onStoresClose"
      :show="configStoreshow"
      title="门店列表"
      :columns="configStorestableColumns"
      :data="configStoresdata"
      :currentPage="storePages.pageNum"
      :total="storePages.total"
      :pageSize="storePages.pageSize"
      :width="1000"
      @handleCurrentChange="handleStoresChange"
    >
      <el-table-column label="门店地址" slot="storeAddress" align="center">
        <template slot-scope="{ row }">
          <el-tooltip :content="row.storeAddress" placement="top">
            <p
              style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;"
            >
              {{ row.storeAddress }}
            </p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="门店店长" slot="storeManager" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeManager || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="店长联系方式"
        slot="storeManagerPhone"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.storeManagerPhone || "--" }}</span>
        </template>
      </el-table-column>
    </DialogTbale>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "Table",
  mixins: [MinXinRequest],
  components: { ElImageViewer },
  data() {
    return {
      loading: false,
      tableColumns: [
        { label: "商家名称", prop: "merchantName" },
        { label: "联系人", prop: "contact" },
        { label: "联系电话", prop: "contactPhone" },
        { slotName: "operationAddress" },
        { label: "建立合作时间", prop: "applyTime" },
        { slotName: "storeCount" },
        { slotName: "quoteMachineType" },
        { slotName: "operation" },
      ],
      seachDataList: [],
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      tipValue: "",
      imgList: [],
      //启用禁用弹窗
      dialogVisible: false,
      dialogTitle: "",
      ShowmerchantId: "",
      EnableType: "",
      dialogWidth: 380,
      showViewer: false,
      configStoreshow: false,
      configStoresdata: [],
      storePages: {
        pageNum: 1,
        pageSize: 10,
        StorespageNum: 1,
        total: 0,
      },
      StoresmerchantId: "",
      configStorestableColumns: [
        { label: "门店名称", prop: "storeName" },
        { slotName: "storeAddress" },
        { slotName: "storeManager" },
        { slotName: "storeManagerPhone" },
        { label: "店员数量", prop: "staffCount" },
        { label: "添加时间", prop: "createTime" },
      ],
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal,'++++++++++++');
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      console.log("表格切换页面", val);
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const params = {
        applyStatus: "01",
        merchantName: this.SeachParams.merchantName,
        contactPhone: this.SeachParams.contactPhone,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.queryUnionList(params).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.page.records;
          this.page.total = res.data.page.total;
          this.page.pageNum = res.data.page.current;
          this.loading = false;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
        this.loading = false;
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 表格操作
    handleBtn(row, type) {
      this.ShowmerchantId = row.merchantCompanyId;
      if (type === "success") {
        this.dialogVisible = true;
        this.dialogTitle = "启用";
        this.EnableType = "success";
        this.tipValue = "确定启用该商家报价吗？";
      }
      //禁用
      else if (type === "danger") {
        this.dialogVisible = true;
        this.dialogTitle = "禁用";
        this.EnableType = "danger";
        this.tipValue = "确定要执行该操作吗？";
      }
    },
    //启用弹窗取消
    resetPopupData() {
      this.dialogVisible = false;
    },
    //启用弹窗确定
    submitPopupData() {
      const params = {
        id: this.ShowmerchantId,
        companyIsEnable: this.EnableType == "danger" ? "02" : "01",
      };
      _api.merchantIsEnable(params).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg);
          this.handleCurrentChange();
        } else {
          this.$message.danger(res.msg);
        }
      });
      this.dialogVisible = false;
    },
    onClose() {
      this.dialogVisible = false;
    },
    seeImg(val) {
      console.log(val);
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(val.businessLicense);
    },
    onStoresClose() {
      this.configStoreshow = false;
      this.StorespageNum = 1;
    },
    //合作门店弹窗
    storeCountFn(row) {
      this.configStoreshow = true;
      this.StoresmerchantId = row.merchantId;
      this.handleStoresChange()
    },
    handleStoresChange(val) {
      if (val) {
        this.storePages.pageNum = val;
      }else{
        this.storePages.pageNum = 1;
      }
      _api
        .StaffManageList({
          merchantId: this.StoresmerchantId,
          pageNum: this.storePages.pageNum,
          pageSize: this.storePages.pageSize,
        })
        .then((res) => {
          this.configStoresdata = res.data.records;
          this.storePages.pageNum = res.data.current;
          this.storePages.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .account {
  }
  .tableBtn {
    color: #0981ff;
    cursor: pointer;
  }
  .handleClass {
    display: inline-block;
    margin-left: 5px;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex-jb {
    justify-content: space-between;
  }
}
</style>
